export function areArraysEqual<T>(arr1: T[], arr2: T[]): boolean {
    const arr1Sorted = arr1.slice().sort()
    const arr2Sorted = arr2.slice().sort()
    if (arr1Sorted.length !== arr2Sorted.length) return false

    return arr1Sorted.every((value, index) => value === arr2Sorted[index])
}
